<template>
	<div class="tcp-top">
		<div class="tcp-promo">
			<p>Enjoy free shipping on orders over $100 USD</p>
		</div>

		<header class="tcp-header">
			<div class="tcp-header__bar">
				<button type="button" class="tcp-icon-btn tcp-header__menu" @click="mobileOpen = !mobileOpen" aria-label="Toggle menu">
					<i class="fa" :class="mobileOpen ? 'fa-times' : 'fa-bars'"></i>
				</button>

				<router-link to="/" class="tcp-logo" @click.native="closeMenus">
					<img :src="logoUrl" alt="The Conscious Pantry">
				</router-link>

				<form class="tcp-search" @submit.prevent="submitSearch">
					<i class="fa fa-search"></i>
					<input
						ref="desktopSearch"
						v-model="query"
						type="search"
						placeholder="Try 'tired', 'stressed', 'energy'..."
					>
				</form>

				<nav class="tcp-nav">
					<div class="tcp-shop" :class="{ 'is-open': shopOpen }">
						<button type="button" class="tcp-nav__link" @click="shopOpen = !shopOpen">
							Shop
							<i class="fa fa-chevron-down"></i>
						</button>
						<div v-if="shopOpen" class="tcp-mega">
							<div class="tcp-mega__grid">
								<div v-for="group in shopGroups" :key="group.title">
									<h3>{{ group.title }}</h3>
									<ul>
										<li v-for="item in group.items" :key="item.id">
											<router-link :to="categoryLink(item)" @click.native="closeMenus">{{ item.name }}</router-link>
										</li>
									</ul>
								</div>
								<div class="tcp-mega__feature">
									<h3>You will love</h3>
									<div class="tcp-mega__photo">
										<img :src="featureUrl" alt="Featured product">
									</div>
									<p class="tcp-mega__name">Daily Wellness Blend</p>
									<p class="tcp-mega__note">Essential vitamins &amp; minerals</p>
									<router-link to="/shop" @click.native="closeMenus">Shop Now →</router-link>
								</div>
							</div>
						</div>
					</div>
					<router-link to="/collections" class="tcp-nav__link" @click.native="closeMenus">Collections</router-link>
					<router-link to="/rituals" class="tcp-nav__link" @click.native="closeMenus">Rituals</router-link>
					<router-link to="/editorial" class="tcp-nav__link" @click.native="closeMenus">Editorial</router-link>
					<router-link to="/about" class="tcp-nav__link" @click.native="closeMenus">About</router-link>
				</nav>

				<div class="tcp-actions">
					<button type="button" class="tcp-icon-btn tcp-actions__search" aria-label="Search" @click="focusSearch">
						<i class="fa fa-search"></i>
					</button>
					<button type="button" class="tcp-icon-btn tcp-actions__lang" aria-label="Language">
						<i class="fa fa-globe"></i>
					</button>
					<router-link to="/login" class="tcp-icon-btn tcp-actions__account" aria-label="Account" @click.native="closeMenus">
						<i class="fa fa-user"></i>
					</router-link>
					<router-link to="/cart" class="tcp-icon-btn tcp-actions__cart" aria-label="Cart" @click.native="closeMenus">
						<i class="fa fa-shopping-bag"></i>
						<span v-if="count" class="tcp-cart-count">{{ count }}</span>
					</router-link>
				</div>
			</div>

			<div v-if="mobileOpen" class="tcp-mobile">
				<form class="tcp-search tcp-search--mobile" @submit.prevent="submitSearch">
					<i class="fa fa-search"></i>
					<input v-model="query" type="search" placeholder="Search products..." autofocus>
				</form>
				<ul>
					<li v-for="link in mobileLinks" :key="link.to">
						<router-link :to="link.to" @click.native="closeMenus">{{ link.label }}</router-link>
					</li>
				</ul>
				<div class="tcp-mobile__actions">
					<router-link to="/login" @click.native="closeMenus">
						<i class="fa fa-user"></i> My Account
					</router-link>
					<router-link to="/cart" @click.native="closeMenus">
						<i class="fa fa-shopping-bag"></i> Cart
						<span v-if="count"> ({{ count }})</span>
					</router-link>
				</div>
			</div>
		</header>
	</div>
</template>

<script>
export default {
	data() {
		return {
			query: '',
			count: 0,
			shopOpen: false,
			mobileOpen: false,
			categories: [],
			logoUrl: tools.url('/public/images/thcp-logo.png'),
			featureUrl: tools.url('/public/images/featured-ingestible-product.jpg'),
			mobileLinks: [
				{ to: '/shop', label: 'Shop' },
				{ to: '/collections', label: 'Collections' },
				{ to: '/rituals', label: 'Rituals' },
				{ to: '/editorial', label: 'Editorial' },
				{ to: '/about', label: 'About' }
			]
		}
	},
	computed: {
		shopGroups() {
			const order = ['Shop by Benefit', 'Shop by Usage', 'Shop by Type']
			return order.map(title => ({
				title: title,
				items: this.categories.filter(row => row.group === title)
			}))
		}
	},
	methods: {
		refresh() {
			this.count = this.$cart.count()
		},
		loadCategories() {
			axios.get(tools.url('/api/store/categories')).then((response) => {
				this.categories = response.data || []
			}).catch(() => {})
		},
		categoryLink(item) {
			return '/shop?category=' + (item.slug || item.id)
		},
		submitSearch() {
			const q = (this.query || '').trim()
			this.closeMenus()
			this.$router.push(q ? { path: '/shop', query: { q: q } } : '/shop')
		},
		focusSearch() {
			if (this.$refs.desktopSearch) {
				this.$refs.desktopSearch.focus()
			}
		},
		closeMenus() {
			this.shopOpen = false
			this.mobileOpen = false
		},
		onDocumentClick(event) {
			if (!this.$el.contains(event.target)) {
				this.shopOpen = false
			}
		}
	},
	watch: {
		'$route'() {
			this.closeMenus()
		}
	},
	mounted() {
		this.refresh()
		this.loadCategories()
		this.$cartBus.$on('change', this.refresh)
		document.addEventListener('click', this.onDocumentClick)
	},
	beforeDestroy() {
		this.$cartBus.$off('change', this.refresh)
		document.removeEventListener('click', this.onDocumentClick)
	}
}
</script>
